module.exports = __webpack_public_path__ + "img/red-circle.022fb90f.png";